import React, { useMemo } from 'react';
import { Chart, Interval, Coordinate, Tooltip, Legend } from 'bizcharts';
import { interpolateYlGnBu } from 'd3-scale-chromatic';
import './PieChartWithLegend.css';


// Function to generate YlGnBu color palette
const getYlGnBuColorScheme = (numColors) => {
  const colors = [];
  for (let i = 0; i < numColors; i++) {
    const ratio = i / (numColors - 1); // Normalize index to 0-1 range
    colors.push(interpolateYlGnBu(ratio));
  }
  return colors;
};

// Convert HEX to RGBA with opacity
const hexToRgba = (hex, opacity) => {
  const bigint = parseInt(hex.slice(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  const newR = Math.round(r + (255 - r) * opacity);
  return `rgba(${newR}, ${g<225 ? g+30:g-30}, ${b}, ${opacity})`;
};

// Pie Chart Component
const PieChartWithLegend = ({ data }) => {
  const colorScheme = useMemo(() => getYlGnBuColorScheme(data.length), [data]);

  return (
    <div className="pie-chart-container">
      <div className="pie-chart-shadow-wrapper">
        {/* BizCharts Donut Chart */}
        <Chart height={400} width={400} data={data} autoFit>
          <Coordinate type="theta" radius={0.75} innerRadius={0.6}/>
          <Tooltip showTitle={false} />
          <Legend visible={false} />
          <Interval
            position="value"
            adjust="stack"
            color={['label', (label) => {
              const index = data.findIndex((item) => item.label === label);
              return colorScheme[index];
            }]}
            style={(item) => {
              const index = data.findIndex(d => d.label === item.label);
              const sliceColor = colorScheme[index];
              return {
               lineWidth: 1,
                stroke: '#fff',
                shadowBlur: 15, // Apply blur to create the shadow
                shadowColor: 'rgba(0, 150, 255, 0.4)', // Set the shadow color to a subtle glow
                shadowOffsetX: 0,
                shadowOffsetY: 0,
              };
            }}
            label={['label', {
              content: (data) => `${data.label}: ${data.value.toFixed(2)}%`,
            }]}
          />
        </Chart>
      </div>

      {/* Custom Legend */}
      <div className="custom-legend">
        {data.map((item, index) => (
          <div key={index} className="legend-item">
            <span
              className="legend-color"
              style={{ backgroundColor: colorScheme[index] }}
            />
            <span className="legend-label">{item.label}</span>
            <span className="legend-value">{item.value.toFixed(2)}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PieChartWithLegend;
